import { WSTable } from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import { useMemo } from "react";
import { columns } from "./columns";

export type TableItemData = IWorkLog;

type Props = {
  workLogs: IWorkLog[];
  onRowClick?: (workLog: IWorkLog) => void;
};

export const TableWorkLogsPayeeView: React.FC<Props> = props => {
  const tableData = useMemo(() => {
    return props.workLogs.map(workLog => ({
      id: workLog.workLogId,
      data: workLog
    }));
  }, [props.workLogs]);

  return (
    <WSTable<TableItemData>
      tableData={tableData}
      columns={columns}
      onRowClick={
        props.onRowClick ? item => props.onRowClick!(item.data) : undefined
      }
    />
  );
};
